<template>
    <router-view :refUid="refUid" :balance="balance" :nameBot="botType"></router-view>
    <AlertMsg v-show="alertMsg.visible" @stopConfirm="getStopConfirm" @terminateConfirm="getTerminateConfirm"
    @showSettingModal="showSettingModal"/>
    <div class="gradient-line"></div>
    <div class="history-wrap">
        <!-- <h3>Balance</h3> -->
        <!-- <div class="total-wrap">
            <span>Total Profit (USDT)</span>
            <p class="plus">+10.25(+0.85%)</p>
        </div> -->
        <div class="balance-container">
            <!-- <div class="balance-wrap">
                <span>Start Balance</span>
                <p>{{ balance[0]?.start_balance }}</p>
            </div>
            <div class="balance-wrap">
                <span>Now Balance</span>
                <p>{{ balance[0]?.now_balance }}</p>
            </div> -->
            <div class="balance-wrap">
                <span>{{ $t("kibot.tpWithUsdt") }}</span>
                <p :class="Number(balance?.total_profit_amount) > 0 ? 'plus' : Number(balance?.total_profit_amount) < 0 ? 'minus' : null">
                    {{ Number(balance?.total_profit_amount) > 0 ? '+' : '' }}{{ balance?.total_profit_amount }}
                    ({{ Number(balance?.total_profit_amount) > 0 ? '+' : '' }}{{ balance?.total_profit_rate }}%)
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { getReferralChk, getBalance } from "@/api/bot/gridBot";


const store = useStore();
const userInfo = computed(() => store.state.userInfo.userInfo);
const alertMsg = computed(() => store.state.usePopupList.alertMsg);

function openAlertMsg(code) {
    store.commit("usePopupList/toggleAlertMsg", { visible: true, code: code });
}

const refUid = ref(''); // 유저 바이낸스 uid
const balance = ref(); // 유저 balance
const botType = ref(''); // 작동 중인 봇 타입

onMounted(async() => {
    try {
        if (userInfo.value.login) {
            // 유저 권한 체크(레퍼럴 등) 
            let chkRef = await getReferralChk(userInfo.value.user_no);
      
            if (chkRef.data.result.status && !chkRef.data.result.bot_status) {
                openAlertMsg('stateBot');
            }
            else if (!chkRef.data.result.status) {
                openAlertMsg('noRef');
            }
            else if (!chkRef.data.result.bot_status) {
                openAlertMsg('stateBot');
            }
            else {
                chkRef.data.result.exchanges.forEach(ob => { 
                    if (ob.exchange == 'binance') {
                        refUid.value = ob.uid;
                    }
                }) 
                
                botType.value = chkRef.data.result.bot_type
            }
    
            // 봇 잔고 get
            let botBalance = await getBalance(userInfo.value.user_no);
            balance.value = botBalance?.data?.result
        }
    }
    catch (error) {
        if (error.response) {
            let errorCode = error.response.data.retCode;
            if (errorCode) {
                openAlertMsg(errorCode);
            } else {
                openAlertMsg();
            }
            return;
        }
    }
   
})
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/bot/bot.scss";
</style>